import type { SxProps, Theme } from '@mui/material/styles';
import type React from 'react';

export const rangeWebkitThumbSx: React.CSSProperties = {
  WebkitAppearance: 'none',
  appearance: 'none',
  width: '12px',
  height: '12px',
  borderRadius: '50%',
  background: 'white',
  marginTop: '-4px',
  cursor: 'pointer',
};

export const rangeMozThumbSx: React.CSSProperties = {
  width: '12px',
  height: '12px',
  borderRadius: '50%',
  background: 'white',
  border: 'none',
  cursor: 'pointer',
};

export const rangeInputSx: SxProps<Theme> = {
  height: '4px',
  borderRadius: '2px',
  cursor: 'pointer',
  outline: 'none',
  border: 'none',
  padding: 0,
  appearance: 'none',
  '&::-webkit-slider-runnable-track': { background: 'transparent', height: '4px', borderRadius: '2px' },
  '&::-webkit-slider-thumb': rangeWebkitThumbSx,
  '&::-moz-range-track': { background: 'transparent', height: '4px', borderRadius: '2px' },
  '&::-moz-range-progress': { background: 'white', height: '4px' },
  '&::-moz-range-thumb': rangeMozThumbSx,
};
